(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('menuService', menuService);

    function menuService($location, enumService, $http, apiUrl, $window, commonService, $timeout) {
        var service = {
            redirectUrl: redirectUrl,
            generateUrl: generateUrl,
            getInformationBySerilNo: getInformationBySerilNo
        };

        var menuUrl = apiUrl.tsApi + 'menu/';

        function getInformationBySerilNo(menuSerilNo, langSerilNo) {
            let newApiURL = menuUrl + 'getByMenuSerilNo/' + menuSerilNo + '/' + langSerilNo;
            newApiURL = commonService.URLCheck(newApiURL)
            //2023-07-20 Johnson 資安2023
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2);',3,3,'http|get|newApiURL'.split('|'),0,{}))
        }

        function redirectUrl(item) {
            var cloneItem = _.cloneDeep(item);
            var param = {
                menuSerilNo: cloneItem.menuSerilNo
            };
            param.menuClickLogCreatePerSerilNo = '';
            param.langSerilNo = '';

            commonService.setParams(param);
            if (sessionStorage.getItem('perSerilNo')) {
                param.menuClickLogCreatePerSerilNo = sessionStorage.getItem('perSerilNo');
            }

            if (sessionStorage.getItem('langCode')) {
                param.langSerilNo = sessionStorage.getItem('langCode');
            }

			$http.post(apiUrl.tsApi + 'log/postFlow', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
						
            $http.post(menuUrl + 'checkMenuIsPass', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function () {
                redirectByTarget(cloneItem, sessionStorage.getItem('token'));
            });
        }

        function redirectByTarget(item, token) {

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            redirectDirect(item, token);

            // if (item.isWindowOpen || item.target === enumService.target.open) {
            //     redirectOpen(item, token);
            //     return;
            // }

            // if (item.target === enumService.target.wrap) {
            //     redirectWrap(item, token);
            //     return;
            // }

            // if (item.target === enumService.target.direct) {
            //     redirectDirect(item, token);
            //     return;
            // }

        }

        // function redirectOpen(item, token) {
        //     generateUrl(item, token);
        //     if (item.isWindowOpen) {
        //         window.open(item.url, 'searchResult');
        //     } else {
        //         window.open(item.url);
        //     }
        // }

        // function redirectWrap(item) {
        //     $location.path('external').search('menu', item.menuSerilNo);
        // }

        function redirectDirect(item, token) {

            if (!isOutSideUrl(item)) {
                $location.path(item.url).search('menu', item.menuSerilNo);
                return;
            }

            if (item.sysCode) {
                //item.url += '?menu=' + item.menuSerilNo;
                generateUrl(item, token);
            }

            $timeout(function () {
                //console.log(item.url);
                $window.location.href = item.url;
            }, 200);
        }


        function generateUrl(item, token) {

            if (!isOutSideUrl(item)) {
                item.url = format('//{0}/#{1}', location.host, item.url);
            }

            if (sessionStorage.getItem('token') && item.sysCode) {

                // 為了避免用戶把網址直接複製給別人
                // 所以如果是自己的功能就不加上Token
                // 如果是其他掛載的頁面，由於不知道是去那裡，所以就給予 token 讓台新其他功能(線上差勤)取用
                var isInitialMenu = item.initialData;

                if (item.url.indexOf('?menu') > -1) {
                    item.url = item.url.split('?menu=')[0];
                    //console.log('1.',item.url);
                    if (isInitialMenu) {
                        item.url += format('?menu={0}', item.menuSerilNo);
                        //console.log('2.',item.url);
                    } else {
                        item.url += format('?tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('3.',item.url);
                    }

                    return;
                }

                if (item.url.indexOf('?') > -1) {

                    if (isInitialMenu) {
                        item.url += format('&menu={0}', item.menuSerilNo);
                        //console.log('4.',item.url);
                    } else {
                        item.url += format('&tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('5.',item.url);
                    }
                    return;
                }

                if (item.url.indexOf('?') === -1) {

                    if (isInitialMenu) {
                        item.url += format('?menu={0}', item.menuSerilNo);
                        //console.log('6.',item.url);
                    } else {
                        item.url += format('?tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('7.',item.url);
                    }
                    return;
                }

            } else {
                if (item.url.indexOf('?menu') > -1) {
                    item.url = item.url.split('?menu=')[0];
                    item.url += format('?menu={0}', item.menuSerilNo);
                    //console.log('8.',item.url);
                    return;
                }

                if (item.url.indexOf('?') > -1) {
                    item.url += format('&menu={0}', item.menuSerilNo);
                    //console.log('9.',item.url);
                    return;
                }

                if (item.url.indexOf('?') === -1) {
                    item.url += format('?menu={0}', item.menuSerilNo);
                    //console.log('10.',item.url);
                    return;
                }
            }
        }

        function isOutSideUrl(item) {

            var result = _.startsWith(item.url, '//') || _.startsWith(item.url, 'http://') ||
                _.startsWith(item.url, 'https://') || _.startsWith(item.url, 'line://');
            return result;
        }

        return service;
    }
})();